import { render, staticRenderFns } from "./goodsNum.vue?vue&type=template&id=774dd5b2&scoped=true"
import script from "./goodsNum.vue?vue&type=script&lang=js"
export * from "./goodsNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774dd5b2",
  null
  
)

export default component.exports